import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  isMenuOpen = false;

  constructor() { }

  ngOnInit(): void {
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    if (this.isMenuOpen) {
      document.documentElement.classList.add('show-menu');
      document.body.classList.add('show-menu');
    } else {
      document.documentElement.classList.remove('show-menu');
      document.body.classList.remove('show-menu');
    }
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    document.documentElement.classList.remove('show-menu');
    document.body.classList.remove('show-menu');
    // Close submenus if any
    const subMenus = document.querySelectorAll('.sub-menu.show');
    subMenus.forEach(menu => menu.classList.remove('show'));
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.closeMenu();
    }
  }
}

